import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Inventory.frontend.types'

@Injectable({ providedIn: 'root' })
export class Inventory_get_inventory_snaphot_rulesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: {  }): Promise<{ list?: { owner_id?: number, project_id?: number, warehouse_id?: number, snapshot_level?: string, owner_lookupcode?: string, project_lookupcode?: string, warehouse_name?: string, id?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Inventory/functions/get_inventory_snaphot_rules`;
    
    const options = {
    }
    
    const body = null;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

